import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { API_URL } from "../../../utils/constant";
import axios from "axios";

export const getResearchSliceContent = createAsyncThunk('/researchs/content', async () => {
    var userData=JSON.parse(localStorage.getItem("userData"));
	const response = await axios.post(`${API_URL}/getResearch`, {});
	return response;
})

export const researchSlice = createSlice({
    name: 'researchs',
    initialState: {
        isLoading: false,
        researchs : []
    },
    reducers: {
    },
    extraReducers: {
		[getResearchSliceContent.pending]: state => {
			state.isLoading = true
		},
		[getResearchSliceContent.fulfilled]: (state, action) => {
			state.researchs = action.payload.data
			state.isLoading = false
		},
		[getResearchSliceContent.rejected]: state => {
			state.isLoading = false
		},
    }
})

export default researchSlice.reducer